/**
 * Filename: home.js
 * Home page
 * Component path
 * IconBoxed  'componenet/iconboxes.js'
 * Charts compoenent from 'compoenent/charts'
 * Table from 'containers/table.js'
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import TopBoxes from '../../../adminCharts/TopBoxes.js';
// import Panel from '../../../components/panel.js';
// import TableComponent from '../../../containers/table.js';
// import IconBoxes from '../../../components/iconBoxes.js';
import LeftPanelToolTip from '../../../adminCharts/LeftPanelToolTip.js';
import RightPanelToolTip from '../../../adminCharts/RightPanelToolTip.js';
import BottonPanelToolTip from '../../../adminCharts/BottonPanelToolTip.js';
import KPIPanelToolTip from '../../../adminCharts/KPIPanelToolTip.js';
import FinancialKPIPanelToolTip from '../../../adminCharts/FinancialKPIPanelToolTip.js';
import OAResponsePanelToolTip from '../../../adminCharts/OAResponsePanelToolTip.js';
import PayerResponsePanelToolTip from '../../../adminCharts/PayerResponsePanelToolTip.js';
// import SimpleAreaChart from '../../../adminCharts/simpleAreaChart.js';
// import SimpleLineChart from '../../../adminCharts/simpleLineChart.js';
import KPIBillableHours from '../../../adminCharts/KPIBillableHours.js';
import KPINonBillableHours from '../../../adminCharts/KPINonBillableHours.js';
import KPICancelledHours from '../../../adminCharts/KPICancelledHours.js';
import KPIPercentageOfCancellation from '../../../adminCharts/KPIPercentageOfCancellation.js';
import AuthorizationTable from '../../../adminCharts/AuthorizationTable.js';
import EncounterTable from '../../../adminCharts/EncounterTable.js';
import StaffEncounterTable from '../../../adminCharts/StaffEncounterTable.js';
import OrganizationStaffDocuemntsTable from '../../../adminCharts/OrganizationStaffDocuemntsTable.js';
import StaffDocuemntsTable from '../../../adminCharts/StaffDocuemntsTable.js';
import { getDashboardData, getOrganizationAuthorization, getOrganizationEncounter, getStaffEncounters, HideStaffPasswordStatusMessage, getOrganizationStaffDocuments, getOrganizationClientDocuments, getStaffDocuments, getClientDocuments, getMasterData, getPatient, getOrganizationBillableHoursGraph, getOrganizationOAResponses, getOrganizationPayerResponses, getOrganizationFinancialKPIGraph } from '../actions/StaffDashboardActions';
import SmallLoader from '../../../img/small-loader.gif';
import { isEmptyObject, showFormatedDate } from '../../../actions/utilAction';
// import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
// import IconButton from 'material-ui/IconButton';
// import IconMenu from 'material-ui/IconMenu';
// import MenuItem from 'material-ui/MenuItem';
// import classNames from 'classnames';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import moment from 'moment';
import OrganizationClientDocuemntsTable from '../../../adminCharts/OrganizationClientDocuemntsTable.js';
import ClientDocuemntsTable from '../../../adminCharts/ClientDocuemntsTable.js';
import OAResponses from '../../../adminCharts/OAResponses.js';
import FinancialKPI_OPENAREXPECTEDAMOUNTS from '../../../adminCharts/FinancialKPI_OPENAREXPECTEDAMOUNTS.js';
import FinancialKPI_OPENCLAIMSBYSTATUS from '../../../adminCharts/FinancialKPI_OPENCLAIMSBYSTATUS.js';
import FinancialKPI_PAYMENTSCOLLECTED from '../../../adminCharts/FinancialKPI_PAYMENTSCOLLECTED.js';
import FinancialKPI_COLLECTIONRATE from '../../../adminCharts/FinancialKPI_COLLECTIONRATE.js';
import FinancialKPI_STAFFBILLING from '../../../adminCharts/FinancialKPI_STAFFBILLING.js';
import FinancialKPI_AMOUNTBILLED from '../../../adminCharts/FinancialKPI_AMOUNTBILLED.js';
import FinancialKPI_PROFITANALYSIS from '../../../adminCharts/FinancialKPI_PROFITANALYSIS.js';
import PayerResponses from '../../../adminCharts/PayerResponses.js';
import KPIScheduledHours from '../../../adminCharts/KPIScheduledHours.js';
import { getExportCSVOrExcelClientDocuments,getExportCSVOrExcelClientNonAdminDocuments,getExportCSVOrExcelStaffDocuments,getExportCSVOrExcelStaffNonAdminDocuments} from '../actions/StaffDashboardActions';
import {getExportCSVOrExcelAuthorizationDocuments } from '../actions/StaffDashboardActions';
import { reduxForm } from 'redux-form';



class StaffDashBoard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      title: 'Authorizations',
      showMessage: true,
      FromBillableHoursDate: new Date(), //new Date().setDate(new Date().getDate() - 30),
      ToBillableHoursDate: new Date(),
      FromOAResponsesDate: new Date().setDate(new Date().getDate() - 90),
      ToOAResponsesDate: new Date(),
      FromFinancialDate: new Date(), //new Date().setDate(new Date().getDate() - 90),
      ToFinancialDate: new Date(),
      FromPayerResponsesDate: new Date().setDate(new Date().getDate() - 90),
      ToPayerResponsesDate: new Date(),
      FromEncounterDate: new Date().setDate(new Date().getDate() - 7),
      ToEncounterDate: new Date(),
      // TotalClientCount: 0,
      // TotalRevenue: 0,
      // OnlineUsers: 0,
      // OrganizationAuthorization: {},
      billablePayerIds: [],
      billableAppointmentTypeIds: [],
      billableStaffIds: [],
      billablePatientIds: [],
      billableLocationIds: [],      
      billableActionName: "Billable Hours",     
      billableKPItitle: "Billable Hours",
      billableKPIsubtitle: "*This chart displays rendered billable hours. All locations, payers, appointment types, staff, and clients are shown by default if none are selected.",
      billableCancelTypeIds: [],
      isBillableHoursOnly: false,    
      financialActionName: "Open A/R Expected Amounts",     
      financialKPItitle:"Open A/R Expected Amounts",
      financialKPIsubtitle: "*This chart displays values based on allowed/expected amounts.",
      financialPayerIds: [],      
      financialStaffIds: [],
      financialPatientIds: [],
      financialLocationIds: [],  
      isfinancialExcludePR: false,    
      billableKPIByWeekOrMonth: 0,
      financialKPIByWeekOrMonth: 0,
      isfinancialIncludeMileage: false,
      isfinancialIncludeDrivetime: false,
      isfinancialIncludeBreak: false,
      isfinancialdisplayByAllowedAmount: false,
      isfinancialSearchBySubmittedDates: false,
      isDepositeDate:false,
      ByWeekOrMonthList: [{ id: 1, value: 'Week' }, { id: 2, value: 'Month' }],
      isExcludeTag: false,
      masterTags: [],
      extension:"",
      SearchObj:null,
    };


      this.renderStaffDashboard = this.renderStaffDashboard.bind(this);
      this.changeMenuItem = this.changeMenuItem.bind(this);
      this.hideMessageClick = this.hideMessageClick.bind(this);
      this.handleBillableChange = this.handleBillableChange.bind(this);
      this.onBillableKPIDateChange = this.onBillableKPIDateChange.bind(this);
      this.onOAResponseDateChange = this.onOAResponseDateChange.bind(this);      
      this.onPayerResponseDateChange = this.onPayerResponseDateChange.bind(this);      
      this.handleFinancialChange  = this.handleFinancialChange.bind(this);            
      this.checkFinancialExcludePR = this.checkFinancialExcludePR.bind(this);
      this.onFinancialKPIDateChange  = this.onFinancialKPIDateChange.bind(this);            
      this.handleBillableReportTypeChange = this.handleBillableReportTypeChange.bind(this);
      this.handleFinancialReportTypeChange = this.handleFinancialReportTypeChange.bind(this);
      this.checkFinancialDisplayByAllowedAmount = this.checkFinancialDisplayByAllowedAmount.bind(this);
      this.checkFinancialSearchBySubmittedDates = this.checkFinancialSearchBySubmittedDates.bind(this);
      this.checkFinancialIncludeMileage = this.checkFinancialIncludeMileage.bind(this);
      this.checkFinancialIncludeDrivetime = this.checkFinancialIncludeDrivetime.bind(this);
      this.checkFinancialIncludeBreak = this.checkFinancialIncludeBreak.bind(this);
      this.handleIsDepositeDate = this.handleIsDepositeDate.bind(this);
      //this.generateFinancialKPIProfitAnalysis = this.generateFinancialKPIProfitAnalysis(this);
  }
  
  ExportCSVOrExcelStaffNonAdminDocuments = ()=>{
    if(this.state.SearchObj===null){
      let searchObj = {
        userId : this.props. loginUserInfo .userID,
        sort_fields: '',
        sort_order: '',
        contain_filters: { SearchText: '' },
        extension:this.state.extension,
       
      };
      this.setState({SearchObj:searchObj},()=>{
        this.props.getExportCSVOrExcelStaffNonAdminDocuments(this.state.SearchObj)
        this.setState({SearchObj:null})
      })
      return
    }
    this.setState((prevState) => ({
      SearchObj: {
        ...prevState.SearchObj,
        extension: this.state.extension,
      }
    }), () => {
      
      this.props.getExportCSVOrExcelStaffNonAdminDocuments(this.state.SearchObj);
    });
  }

  ExportCSVOrExcelClientNonAdminDocuments = ()=>{
    if(this.state.SearchObj===null){
      let searchObj = {
        userId : this.props. loginUserInfo .userID,
        sort_fields: '',
        sort_order: '',
        contain_filters: { SearchText: '' },
        extension:this.state.extension,
        viewTeamClientsOnly:this.props.viewTeamClientsOnlyPermission?1:0
      };
      this.setState({SearchObj:searchObj},()=>{
        this.props.getExportCSVOrExcelClientNonAdminDocuments(this.state.SearchObj)
        this.setState({SearchObj:null})
      })
      return
    }
    this.setState((prevState) => ({
      SearchObj: {
        ...prevState.SearchObj,
        extension: this.state.extension,
        viewTeamClientsOnly:this.props.viewTeamClientsOnlyPermission?1:0
      }
    }), () => {
      
      this.props.getExportCSVOrExcelClientNonAdminDocuments(this.state.SearchObj);
    });
  }

  ExportCSVOrExcelOrganizationClientDocuments  = ()=>{
    if(this.state.SearchObj===null){
      let searchObj = {
        pageNumber: 1,
        pageSize: 10,
        sort_fields: '',
        sort_order: '',
        contain_filters: { SearchText: '' },
        extension:this.state.extension
      };
      this.setState({SearchObj:searchObj},()=>{
        this.props.getExportCSVOrExcelClientDocuments(this.state.SearchObj)
        this.setState({SearchObj:null})
      })
      return
    }
    this.setState((prevState) => ({
      SearchObj: {
        ...prevState.SearchObj,
        extension: this.state.extension 
      }
    }), () => {
      
      this.props.getExportCSVOrExcelClientDocuments(this.state.SearchObj);
    });
    
  }

 


  ExportCSVOrExcelOrganizationStaffDocuments  = ()=>{
    if(this.state.SearchObj===null){
      let searchObj = {
        pageNumber: 1,
        pageSize: 10,
        sort_fields: '',
        sort_order: '',
        contain_filters: { SearchText: '' },
        extension:this.state.extension
      };
      this.setState({SearchObj:searchObj},()=>{
        this.props.getExportCSVOrExcelStaffDocuments(this.state.SearchObj)
        this.setState({SearchObj:null})
      })
      return
    }
    this.setState((prevState) => ({
      SearchObj: {
        ...prevState.SearchObj,
        extension: this.state.extension 
      }
    }), () => {
      
      this.props.getExportCSVOrExcelStaffDocuments(this.state.SearchObj);
    });
    
  }

  ExportCSVOrExcelOrganizationClientDocumentsParamGetter=(searchObj1)=>{
    let searchObj = {
      pageNumber: searchObj1.pageNumber||1,
      pageSize: 10,
      sort_fields: searchObj1.sort_fields || '',
      sort_order: searchObj1.sort_order || '',
      contain_filters: { SearchText:searchObj1.contain_filters.SearchText|| '' },
    };
    this.setState({SearchObj:searchObj})
  }
  extensionGetter = (extension)=>{
     this.setState({extension:extension})  
  }



  ExportCSVOrExcelOrganizationAuthorizationsDocuments  = ()=>{
    if(this.state.SearchObj===null){
      let searchObj = {
        pageNumber: 1,
        pageSize: 10,
        sort_fields: '',
        sort_order: '',
        contain_filters: { SearchText: '' },
        extension:this.state.extension,
        viewTeamClientsOnly:this.props.viewTeamClientsOnlyPermission?1:0
      };
      this.setState({SearchObj:searchObj},()=>{
        this.props.getExportCSVOrExcelAuthorizationDocuments(this.state.SearchObj)
        this.setState({SearchObj:null})
      })
      return
    }
    this.setState((prevState) => ({
      SearchObj: {
        ...prevState.SearchObj,
        extension: this.state.extension,
        viewTeamClientsOnly:this.props.viewTeamClientsOnlyPermission?1:0 
      }
    }), () => {
      
      this.props.getExportCSVOrExcelAuthorizationDocuments(this.state.SearchObj);
    });
    
  }


  ExportCSVOrExcelOrganizationAuthorizationDocumentsParamGetter=(searchObj1)=>{
    let searchObj = {
      pageNumber: searchObj1.pageNumber||1,
      pageSize: 10,
      sort_fields: searchObj1.sort_fields || '',
      sort_order: searchObj1.sort_order || '',
      contain_filters: { SearchText:searchObj1.contain_filters.SearchText|| '' },
      viewTeamClientsOnly: searchObj1. viewTeamClientsOnly
    };
    this.setState({SearchObj:searchObj})
  }


 












  loadAdminDasboardDetails(page_number) {
    this.props.getDashboardData();
    let searchObj = {
      pageNumber: page_number ? page_number : 1,
      pageSize: 10,
      contain_filters: {
        viewTeamClientsOnly: '0',
      },        
    };
    this.props.getOrganizationAuthorization(searchObj);

    let searchObj11 = {
      pageNumber: page_number ? page_number : 1,
      pageSize: 10,
      sortColumn:'',
      sortOrder:'',
      fromDate:this.state.FromEncounterDate ? showFormatedDate(this.state.FromEncounterDate) : new Date(new Date().setDate(new Date().getDate() - 7))||'',
      toDate:this.state.ToEncounterDate ? showFormatedDate(this.state.ToEncounterDate) :new Date(new Date().setDate(new Date().getDate()))||'',
      searchText:'',
    };
    this.props.getOrganizationEncounter(searchObj11);

    let searchObj1 = {
      pageNumber: page_number ? page_number : 1,
      pageSize: 10,
    };
    this.props.getOrganizationStaffDocuments(searchObj1);

    let searchObjSecond = {
      pageNumber: page_number ? page_number : 1,
      pageSize: 10,
    };
    this.props.getOrganizationClientDocuments(searchObjSecond);
    
    let masterData = {
      'masterdata': 'MASTERALLSTAFF,MASTERSTAFFACTIVEANDINACTIVE,APPOINTMENTTYPE,MASTERTAGSFORALL,BILLABLEAPPOINTMENTTYPE,NONBILLABLEAPPOINTMENTTYPE,MASTERINSURANCECOMPANY,MASTERCANCELTYPE',
    };    
    this.props.getMasterData(masterData);    

    let searchObj2 = {
      locationIds: '0',
      isActiveCheckRequired: 'NO',
    };
    this.props.getPatient(searchObj2);  

    this.loadOrganizationBillableHoursGraph();    
      
    this.loadOrganizationOAResponses();    

    this.loadOrganizationFinancialKPIGraph();

    this.loadOrganizationPayerResponses();    
  }

  loadOrganizationBillableHoursGraph() {
    let searchObj3 = {     
      contain_filters: {
        fromDate: this.state.FromBillableHoursDate ? moment(this.state.FromBillableHoursDate).format('YYYY-MM-DD') : new Date(),
        toDate: this.state.ToBillableHoursDate ? moment(this.state.ToBillableHoursDate).format('YYYY-MM-DD') : new Date(),
        locationIds: this.state.billableLocationIds.length > 0 ? this.state.billableLocationIds : '',
        payerIds: this.state.billablePayerIds.length > 0 ? this.state.billablePayerIds : '',
        appointmentTypeIds: this.state.billableAppointmentTypeIds.length > 0 ? this.state.billableAppointmentTypeIds : '',
        patientIds: this.state.billablePatientIds.length > 0 ? this.state.billablePatientIds : '',
        staffIds: this.state.billableStaffIds.length > 0 ? this.state.billableStaffIds : '', 
        cancelTypeIds: this.state.billableCancelTypeIds.length > 0 ? this.state.billableCancelTypeIds : '',  
        byWeekOrMonth: this.state.billableKPIByWeekOrMonth || 0,  
        actionName: this.state.billableActionName, 
        isBillableHoursOnly: this.state.isBillableHoursOnly ? true : false,
        tagIds: this.state.masterTags,
        isExcludeTag: this.state.isExcludeTag,
      }, 
    };

    this.props.getOrganizationBillableHoursGraph(searchObj3);
  }

  loadOrganizationFinancialKPIGraph() {
    let searchObj4 = {     
      contain_filters: {
        fromDate: this.state.FromFinancialDate ? moment(this.state.FromFinancialDate).format('YYYY-MM-DD') : new Date(),
        toDate: this.state.ToFinancialDate ? moment(this.state.ToFinancialDate).format('YYYY-MM-DD') : new Date(),        
        payerIds: this.state.financialPayerIds.length > 0 ? this.state.financialPayerIds : '',        
        patientIds: this.state.financialPatientIds.length > 0 ? this.state.financialPatientIds : '',
        staffIds: this.state.financialStaffIds.length > 0 ? this.state.financialStaffIds : '',         
        isExcludePR: this.state.isfinancialExcludePR ? true : false,   
        isExcludeOverpaymentStatus: this.state.isfinancialExcludeOverpaymentStatus ? true : false,   
        byWeekOrMonth: this.state.financialKPIByWeekOrMonth || 0,      
        displayByAllowedAmount: this.state.isfinancialdisplayByAllowedAmount ? true : false,     
        searchBySubmittedDates: this.state.isfinancialSearchBySubmittedDates ? true : false,
        isIncludeMileage: this.state.isfinancialIncludeMileage ? true : false,
        isIncludeDriveTime: this.state.isfinancialIncludeDrivetime ? true : false,
        isIncludePaidBreak: this.state.isfinancialIncludeBreak ? true : false,
        actionName: this.state.financialActionName, 
        isDepositedDate:this.state.financialActionName=="Payments Collected" && this.state.isDepositeDate==true ? true :false,
        locationIds: this.state.financialLocationIds.length > 0 ? this.state.financialLocationIds : '',
        viewTeamClientsOnly: this.props.viewTeamClientsOnlyPermission,
      }, 
    };

    this.props.getOrganizationFinancialKPIGraph(searchObj4);
    this.setState({isDepositeDate:false});
  }

  loadOrganizationOAResponses(page_number) {
    let searchObj3 = {    
      pageNumber: page_number ? page_number : 1,
      pageSize: 10, 
      contain_filters: {
        fromDate: this.state.FromOAResponsesDate ? moment(this.state.FromOAResponsesDate).format('YYYY-MM-DD') : new Date(),
        toDate: this.state.ToOAResponsesDate ? moment(this.state.ToOAResponsesDate).format('YYYY-MM-DD') : new Date(),      
      }, 
    };

    this.props.getOrganizationOAResponses(searchObj3);
  }

  loadOrganizationPayerResponses(page_number) {
    let searchObj3 = {    
      pageNumber: page_number ? page_number : 1,
      pageSize: 10, 
      contain_filters: {
        fromDate: this.state.FromPayerResponsesDate ? moment(this.state.FromPayerResponsesDate).format('YYYY-MM-DD') : new Date(),
        toDate: this.state.ToPayerResponsesDate ? moment(this.state.ToPayerResponsesDate).format('YYYY-MM-DD') : new Date(),      
      }, 
    };

    this.props.getOrganizationPayerResponses(searchObj3);
  }

  loadStaffDasboardDetails(page_number) {
    if(this.props.viewStaffAndClientOnDashboadPermission === true)
    {
      this.props.getDashboardData();
    }
    if(this.props.authorizationPermission)
    {
      let searchObj = {
        pageNumber: page_number ? page_number : 1,
        pageSize: 10,
        contain_filters: {
          viewTeamClientsOnly: this.props.viewTeamClientsOnlyPermission ? '1' : '0',
        },        
      };
      this.props.getOrganizationAuthorization(searchObj);
    }
    let searchObj1 = {
      pageNumber: page_number ? page_number : 1,
      pageSize: 10,
      sortColumn:'',
      sortOrder:'',
      fromDate:this.state.FromEncounterDate ? showFormatedDate(this.state.FromEncounterDate) : new Date(new Date().setDate(new Date().getDate() - 7))||'',
      toDate:this.state.ToEncounterDate ? showFormatedDate(this.state.ToEncounterDate) :new Date(new Date().setDate(new Date().getDate()))||'',
      searchText:'',
    };
    this.props.getStaffEncounters(searchObj1);

    if(this.props.staffDocumentPermission)
    {
      let searchObj2 = {
        userId: 0,
        pageNumber: page_number ? page_number : 1,
        pageSize: 10,        
      };
      this.props.getStaffDocuments(searchObj2);
    }

    if(this.props.clientDocumentPermission)
    {
      let searchObj2 = {
        userId: 0,
        pageNumber: page_number ? page_number : 1,
        pageSize: 10,     
        contain_filters: {
          viewTeamClientsOnly: this.props.viewTeamClientsOnlyPermission ? '1' : '0',
        },    
      };
      this.props.getClientDocuments(searchObj2);
    }

    if(this.props.billableKPIOnDashboadPermission === true || this.props.financialSummaryKPIOnDashboadPermission === true)
    {
      let masterData = {
        'masterdata': 'MASTERALLSTAFF,MASTERSTAFFACTIVEANDINACTIVE,MASTERTAGSFORALL,APPOINTMENTTYPE,BILLABLEAPPOINTMENTTYPE,NONBILLABLEAPPOINTMENTTYPE,MASTERINSURANCECOMPANY,MASTERCANCELTYPE',
      };          
      this.props.getMasterData(masterData);    

      let searchObj2 = {
        locationIds: '0',
        isActiveCheckRequired: 'NO',
      };
      this.props.getPatient(searchObj2);  

      this.loadOrganizationOAResponses();    

      this.loadOrganizationBillableHoursGraph();    
      
      this.loadOrganizationFinancialKPIGraph();  

      this.loadOrganizationPayerResponses();    
    }

  }

  componentWillMount() {
    if (this.props.loginUserInfo.userRoles.userType === 'ADMIN') {
      this.loadAdminDasboardDetails(1);
    } else {
      this.loadStaffDasboardDetails(1);
    }
  }
  changeMenuItem(title) {
    this.setState({
      title: title,
    });
  }

  hideMessageClick() {
    this.setState({ showMessage: false });
    this.props.HideStaffPasswordStatusMessage();
  }

  handleBillableChange = (input, selectedRecord) => {          
    if (input.name === 'billablePayerIds') {
      this.setState({billablePayerIds: selectedRecord},()=>{this.loadOrganizationBillableHoursGraph(); });
    } 
    else if (input.name === 'billableAppointmentTypeIds') {
      this.setState({billableAppointmentTypeIds: selectedRecord},()=>{this.loadOrganizationBillableHoursGraph(); });
    }
    else if (input.name === 'billableStaffIds') {
      this.setState({billableStaffIds: selectedRecord},()=>{this.loadOrganizationBillableHoursGraph(); });
    }    
    else if (input.name === 'billablePatientIds') {
      this.setState({billablePatientIds: selectedRecord},()=>{this.loadOrganizationBillableHoursGraph(); });
    }
    else if (input.name === 'billableLocationIds') {
      this.setState({billableLocationIds: selectedRecord},()=>{this.loadOrganizationBillableHoursGraph(); });
    }
    else if (input.name === 'billableCancelTypeIds') {
      this.setState({billableCancelTypeIds: selectedRecord},()=>{this.loadOrganizationBillableHoursGraph(); });
    }
    input.onChange(selectedRecord);       
  }

  handleTagChange = (input, selectedValues) => {
    if (input.name === 'tags') {      
        input.onChange(selectedValues);
        this.setState({
          masterTags: selectedValues,
        }, () => {this.loadOrganizationBillableHoursGraph();}) 
    }
  }

  isExcludeTagHandler = (e) => {
    this.setState({
      isExcludeTag: !this.state.isExcludeTag
    },() => {this.loadOrganizationBillableHoursGraph();});
  }

  handleBillableReportTypeChange = (input, selectedRecord) => {          
    input.onChange(selectedRecord.value);
    this.setState({billableKPIByWeekOrMonth: selectedRecord.value},()=>{this.loadOrganizationBillableHoursGraph(); });
  }

  onBillableKPIDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value },()=>{this.loadOrganizationBillableHoursGraph(); });    
  }

  onOAResponseDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value },()=>{this.loadOrganizationOAResponses(); });    
  }

  onPayerResponseDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value },()=>{this.loadOrganizationPayerResponses(); });    
  }

  handleResetBillableKPI = () => {    
    this.setState({      
      FromBillableHoursDate: new Date().setDate(new Date().getDate() - 30),
      ToBillableHoursDate: new Date(),     
      billablePayerIds: [],
      billableAppointmentTypeIds: [],
      billableStaffIds: [],
      billablePatientIds: [],
      billableLocationIds: [], 
      billableCancelTypeIds: [],
      billableKPIByWeekOrMonth: 0,
      isBillableHoursOnly: false,
    },()=>{this.loadOrganizationBillableHoursGraph(); });
  };

  handleChangeBillableKPI = (billableKPItitle,billableKPIsubtitle) => {  
    if(this.state.billableKPItitle !== billableKPItitle)
    {
      this.setState({   
        FromBillableHoursDate: new Date().setDate(new Date().getDate() - 30),
        ToBillableHoursDate: new Date(),
        billablePayerIds: [],
        billableAppointmentTypeIds: [],
        billableStaffIds: [],
        billablePatientIds: [],
        billableLocationIds: [], 
        billableCancelTypeIds: [],   
        billableKPItitle: billableKPItitle,
        billableKPIsubtitle: billableKPIsubtitle,   
        billableActionName: billableKPItitle, 
        billableKPIByWeekOrMonth: 0,       
        isBillableHoursOnly: false,
      },()=>{           
        this.loadOrganizationBillableHoursGraph();     
      }); 
    }
    else{
      this.setState({   
        // billablePayerIds: [],
        // billableAppointmentTypeIds: [],
        // billableStaffIds: [],
        // billablePatientIds: [],
        // billableLocationIds: [], 
        billableCancelTypeIds: [],   
        billableKPItitle: billableKPItitle,
        billableKPIsubtitle: billableKPIsubtitle,   
        billableActionName: billableKPItitle, 
        billableKPIByWeekOrMonth: 0,               
      },()=>{            
        this.loadOrganizationBillableHoursGraph();     
      });    
    }
  };

  checkBillableAllHoursStatus = (e) => {
    if(e.target.checked) 
    {
      this.setState({isBillableHoursOnly : true},()=>{this.loadOrganizationBillableHoursGraph(); });        
    }
    else
    {
      this.setState({isBillableHoursOnly : false},()=>{this.loadOrganizationBillableHoursGraph(); });
    }
}

  handleFinancialReportTypeChange = (input, selectedRecord) => {          
    input.onChange(selectedRecord.value);
    this.setState({financialKPIByWeekOrMonth: selectedRecord.value},()=>{this.loadOrganizationFinancialKPIGraph(); });
  }

  handleFinancialChange = (input, selectedRecord) => {          
    if (input.name === 'financialPayerIds') {
      this.setState({financialPayerIds: selectedRecord},()=>{this.loadOrganizationFinancialKPIGraph(); });
    }    
    else if (input.name === 'financialStaffIds') {
      this.setState({financialStaffIds: selectedRecord},()=>{
        if(this.state.financialKPItitle !== "Profit Analysis")
          this.loadOrganizationFinancialKPIGraph(); 
      });
    }    
    else if (input.name === 'financialPatientIds') {
      this.setState({financialPatientIds: selectedRecord},()=>{this.loadOrganizationFinancialKPIGraph(); });
    }
    else if (input.name === 'financialLocationIds') {
      this.setState({financialLocationIds: selectedRecord},()=>{this.loadOrganizationFinancialKPIGraph(); });
    }
    
    input.onChange(selectedRecord);       
  }

  checkFinancialExcludePR = (e, name) => {
    if (name === 'isExcludePR') {
      if(e.target.checked) 
      {
        this.setState({isfinancialExcludePR : true},()=>{this.loadOrganizationFinancialKPIGraph(); });        
      }
      else
      {
        this.setState({isfinancialExcludePR : false},()=>{this.loadOrganizationFinancialKPIGraph(); });
      }
    }
    else if (name === 'isExcludeOverpaymentStatus') {
      if(e.target.checked) 
      {
        this.setState({isfinancialExcludeOverpaymentStatus : true},()=>{this.loadOrganizationFinancialKPIGraph(); });        
      }
      else
      {
        this.setState({isfinancialExcludeOverpaymentStatus : false},()=>{this.loadOrganizationFinancialKPIGraph(); });
      }
    }
  }

  handleIsDepositeDate = (e) => {
    const isChecked = e.target.checked;
    this.setState({ isDepositeDate: isChecked }, () => {
      this.loadOrganizationFinancialKPIGraph();
    });
  }

  checkFinancialDisplayByAllowedAmount = (e) => {
    if(e.target.checked) 
    {
      this.setState({isfinancialdisplayByAllowedAmount : true},()=>{this.loadOrganizationFinancialKPIGraph(); });        
    }
    else
    {
      this.setState({isfinancialdisplayByAllowedAmount : false},()=>{this.loadOrganizationFinancialKPIGraph(); });
    }
  }

  checkFinancialSearchBySubmittedDates = (e) => {
    if(e.target.checked) 
    {
      this.setState({isfinancialSearchBySubmittedDates : true},()=>{this.loadOrganizationFinancialKPIGraph(); });        
    }
    else
    {
      this.setState({isfinancialSearchBySubmittedDates : false},()=>{this.loadOrganizationFinancialKPIGraph(); });
    }
  } 

  checkFinancialIncludeMileage = (e) => {
    if(e.target.checked) 
    {
      this.setState({isfinancialIncludeMileage : true},()=>{
        if(this.state.financialKPItitle !== "Profit Analysis")
          this.loadOrganizationFinancialKPIGraph(); 
      });        
    }
    else
    {
      this.setState({isfinancialIncludeMileage : false},()=>{
        if(this.state.financialKPItitle !== "Profit Analysis")
          this.loadOrganizationFinancialKPIGraph(); 
      });        
    }
  } 

  checkFinancialIncludeDrivetime = (e) => {
    if(e.target.checked) 
    {
      this.setState({isfinancialIncludeDrivetime : true},()=>{
        if(this.state.financialKPItitle !== "Profit Analysis")
          this.loadOrganizationFinancialKPIGraph(); 
      });        
    }
    else
    {
      this.setState({isfinancialIncludeDrivetime : false},()=>{
        if(this.state.financialKPItitle !== "Profit Analysis")
          this.loadOrganizationFinancialKPIGraph(); 
      });        
    }
  } 

  checkFinancialIncludeBreak = (e) => {
    if(e.target.checked) 
    {
      this.setState({isfinancialIncludeBreak : true},()=>{
        if(this.state.financialKPItitle !== "Profit Analysis")
          this.loadOrganizationFinancialKPIGraph(); 
      });        
    }
    else
    {
      this.setState({isfinancialIncludeBreak : false},()=>{
        if(this.state.financialKPItitle !== "Profit Analysis")
          this.loadOrganizationFinancialKPIGraph(); 
      });
    }
  } 

  generateFinancialKPIProfitAnalysis = () => {
    this.loadOrganizationFinancialKPIGraph(); 
  }
  
  onFinancialKPIDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value },()=>{ 
      if(this.state.financialKPItitle !== "Profit Analysis")
          this.loadOrganizationFinancialKPIGraph(); 
    });    
  }

  handleResetFinancialKPI = () => {    
    this.setState({      
      FromFinancialDate: new Date().setDate(new Date().getDate() - 90),
      ToFinancialDate: new Date(),     
      financialPayerIds: [],      
      financialStaffIds: [],
      financialPatientIds: [],
      financialLocationIds: [],      
      isfinancialExcludePR : false,  
      isfinancialExcludeOverpaymentStatus: false,
      financialKPIByWeekOrMonth: 0,
      isfinancialdisplayByAllowedAmount: false,
      isfinancialSearchBySubmittedDates: false,
    },()=>{this.loadOrganizationFinancialKPIGraph(); });
  };

  handlechangeFinancialKPI = (financialKPItitle,financialKPIsubtitle) => {      
    if(this.state.financialKPItitle !== financialKPItitle)
    {
      this.setState({      
        FromFinancialDate: new Date().setDate(new Date().getDate() - 90),
        ToFinancialDate: new Date(),    
        financialPayerIds: [],      
        financialStaffIds: [],
        financialPatientIds: [],
        financialLocationIds:[],  
        financialKPItitle: financialKPItitle,
        financialKPIsubtitle: financialKPIsubtitle,   
        financialActionName: financialKPItitle,        
        isfinancialExcludePR : false,  
        isfinancialExcludeOverpaymentStatus: false,
        financialKPIByWeekOrMonth: 0,
        isfinancialdisplayByAllowedAmount: false,
        isfinancialSearchBySubmittedDates: false,
        FromFinancialDate: financialKPItitle !== "Profit Analysis" ? new Date().setDate(new Date().getDate() - 90) : new Date(),
        ToFinancialDate: new Date(),
      },()=>{
        //if(this.state.financialKPItitle !== "Profit Analysis")          
          this.loadOrganizationFinancialKPIGraph(); 
      });
    }
    else {
      this.setState({      
        // financialPayerIds: [],      
        // financialStaffIds: [],
        // financialPatientIds: [],  
        financialKPItitle: financialKPItitle,
        financialKPIsubtitle: financialKPIsubtitle,   
        financialActionName: financialKPItitle,        
        isfinancialExcludePR : false,  
        isfinancialExcludeOverpaymentStatus: false,
        financialKPIByWeekOrMonth: 0,
        isfinancialdisplayByAllowedAmount: false,
        isfinancialSearchBySubmittedDates: false,
        FromFinancialDate: financialKPItitle !== "Profit Analysis" ? new Date().setDate(new Date().getDate() - 90) : new Date(),
        ToFinancialDate: new Date(),
      },()=>{
        //if(this.state.financialKPItitle !== "Profit Analysis")          
          this.loadOrganizationFinancialKPIGraph(); 
      });
    }
  };

  handleResetOAResponse = () => {    
    this.setState({      
      FromOAResponsesDate: new Date().setDate(new Date().getDate() - 90),
      ToOAResponsesDate: new Date(),           
    },()=>{this.loadOrganizationOAResponses(); });
  };

  handleResetPayerResponse = () => {    
    this.setState({      
      FromPayerResponsesDate: new Date().setDate(new Date().getDate() - 90),
      ToPayerResponsesDate: new Date(),           
    },()=>{this.loadOrganizationPayerResponses(); });
  };

  renderAdminDashboard1() {
    return (
      <div>
        {/* {this.props.OrganizationEncounter && !isEmptyObject(this.props.OrganizationEncounter) ?
          <TopBoxes TotalClientCount={this.props.TotalClientCount} TotalStaffCount={this.props.TotalStaffCount} TotalRevenue={null} OnlineUsers={this.props.OnlineUsers} />
          :
          <TopBoxes TotalClientCount={this.props.TotalClientCount} TotalStaffCount={this.props.TotalStaffCount} TotalRevenue={null} OnlineUsers={this.props.OnlineUsers} />
        }  */}

        <TopBoxes TotalClientCount={this.props.TotalClientCount} TotalStaffCount={this.props.TotalStaffCount} TotalRevenue={null} OnlineUsers={this.props.OnlineUsers} />
        <div className="row dashboardchart">          
          <div className="col-md-6 mb-30">
            {this.props.RightPanel_loading ?
              <div className="full_loader top0">
                <div className="small-loader">
                  <img src={SmallLoader} alt="" />
                </div>
              </div>
              : null}

            <RightPanelToolTip
              extensionGetter = {this.extensionGetter}
              downLoadAuthDocs = {this.ExportCSVOrExcelOrganizationAuthorizationsDocuments}
              title="Authorizations"
              righticon={false}>
              <AuthorizationTable SendQueryparams = {this. ExportCSVOrExcelOrganizationAuthorizationDocumentsParamGetter} OrganizationAuthorization={this.props.OrganizationAuthorization} />
            </RightPanelToolTip>
          </div>
          <div className="col-md-6 mb-30">
            {this.props.LeftPanel_loading ?
              <div className="full_loader top0">
                <div className="small-loader">
                  <img src={SmallLoader} alt="" />
                </div>
              </div>
              : null}

            <LeftPanelToolTip
              extensionGetter = {this.extensionGetter}
              downLoadStaffDocs = {this.ExportCSVOrExcelOrganizationStaffDocuments}
              title="Staff Documents"
              righticon={false}>
              <OrganizationStaffDocuemntsTable SendQueryparams = {this.ExportCSVOrExcelOrganizationClientDocumentsParamGetter}  OrganizationStaffDocmuents={this.props.OrganizationStaffDocmuents} />
            </LeftPanelToolTip>
            
          </div>
          <div className="col-md-6 mb-30">
            {this.props.LeftPanel_loading ?
              <div className="full_loader top0">
                <div className="small-loader">
                  <img src={SmallLoader} alt="" />
                </div>
              </div>
              : null}

            <LeftPanelToolTip
              title="Client Documents"
              extensionGetter = {this.extensionGetter}
              downLoadClientDocs = {this.ExportCSVOrExcelOrganizationClientDocuments}
              righticon={false}>
              <OrganizationClientDocuemntsTable SendQueryparams = {this.ExportCSVOrExcelOrganizationClientDocumentsParamGetter} OrganizationClientDocmuents={this.props.OrganizationClientDocmuents} />
            </LeftPanelToolTip>
          </div>
        </div>
       
          <div className="row dashboardchart">          
            <div className="col-md-12 mb-30">
              {this.props.OAResponse_loading ?
                <div className="full_loader top0">
                  <div className="small-loader">
                    <img src={SmallLoader} alt="" />
                  </div>
                </div>
                : null}
              <OAResponsePanelToolTip
                title="Clearinghouse Rejections"
                righticon={false}
                FromOAResponsesDate = {this.state.FromOAResponsesDate}
                ToOAResponsesDate = {this.state.ToOAResponsesDate}>
                 {this.props.OrganizationOAResponses && !isEmptyObject(this.props.OrganizationOAResponses) ?
                      <OAResponses FromOAResponsesDate={this.state.FromOAResponsesDate} ToOAResponsesDate={this.state.ToOAResponsesDate}                       
                      onOAResponseDateChange={this.onOAResponseDateChange}  handleResetOAResponse= {this.handleResetOAResponse} 
                      OrganizationOAResponses={this.props.OrganizationOAResponses}  />
                    :
                      <OAResponses FromOAResponsesDate={this.state.FromOAResponsesDate} ToOAResponsesDate={this.state.ToOAResponsesDate}                       
                          onOAResponseDateChange={this.onOAResponseDateChange}  handleResetOAResponse= {this.handleResetOAResponse} 
                          OrganizationOAResponses={null} />
                  } 
              </OAResponsePanelToolTip>
            </div>
          </div> 

          <div className="row dashboardchart">           
            <div className="col-md-12 mb-30">
              {this.props.PayerResponse_loading ?
                <div className="full_loader top0">
                  <div className="small-loader">
                    <img src={SmallLoader} alt="" />
                  </div>
                </div>
                : null}
              <PayerResponsePanelToolTip
                title="Payer Denials"
                righticon={false}
                FromPayerResponsesDate = {this.state.FromPayerResponsesDate}
                ToPayerResponsesDate = {this.state.ToPayerResponsesDate}
                >
                 {this.props.OrganizationPayerResponses && !isEmptyObject(this.props.OrganizationPayerResponses) ?
                      <PayerResponses FromPayerResponsesDate={this.state.FromPayerResponsesDate} ToPayerResponsesDate={this.state.ToPayerResponsesDate}                       
                      onPayerResponseDateChange={this.onPayerResponseDateChange}  handleResetPayerResponse= {this.handleResetPayerResponse} 
                      OrganizationPayerResponses={this.props.OrganizationPayerResponses}  />
                    :
                      <PayerResponses FromPayerResponsesDate={this.state.FromPayerResponsesDate} ToPayerResponsesDate={this.state.ToPayerResponsesDate}                       
                          onPayerResponseDateChange={this.onPayerResponseDateChange}  handleResetPayerResponse= {this.handleResetPayerResponse} 
                          OrganizationPayerResponses={null} />
                  } 
              </PayerResponsePanelToolTip>
            </div>
          </div> 
        
          <div className="row dashboardchart">          
            <div className="col-md-12 mb-30">
              {this.props.BillableKPI_loading ?
                <div className="full_loader top0">
                  <div className="small-loader">
                    <img src={SmallLoader} alt="" />
                  </div>
                </div>
                : null}
              <KPIPanelToolTip
                billableKPItitle={this.state.billableKPItitle}
                billableKPIsubtitle= {this.state.billableKPIsubtitle}
                righticon={true}
                handleChangeBillableKPI= {this.handleChangeBillableKPI}>                
                {this.state.billableActionName === 'Billable Hours' && 
                    <KPIBillableHours FromBillableHoursDate={this.state.FromBillableHoursDate} ToBillableHoursDate={this.state.ToBillableHoursDate} handleBillableChange={this.handleBillableChange} userLocationList={this.props.userLocationList} 
                      masterInsuranceCompanies={this.props.masterInsuranceCompanies} billableAppointmentType={this.props.billableAppointmentType} allStaffs={this.props.allStaffs}
                      patientlist={this.props.patientlist} onBillableKPIDateChange={this.onBillableKPIDateChange} dataAnalytics={this.props.dataAnalytics} handleResetBillableKPI= {this.handleResetBillableKPI} handleBillableReportTypeChange={this.handleBillableReportTypeChange} ByWeekOrMonthList={this.state.ByWeekOrMonthList} 
                      masterTagsForAll={this.props.masterTagsForAll} isExcludeTagHandler = {this.isExcludeTagHandler} handleTagChange={this.handleTagChange}/>}
                {this.state.billableActionName === 'Non-Billable Hours' && 
                    <KPINonBillableHours FromBillableHoursDate={this.state.FromBillableHoursDate} ToBillableHoursDate={this.state.ToBillableHoursDate} handleBillableChange={this.handleBillableChange} userLocationList={this.props.userLocationList} 
                      masterInsuranceCompanies={this.props.masterInsuranceCompanies} nonBillableAppointmentType={this.props.nonBillableAppointmentType} allStaffs={this.props.allStaffs}
                      patientlist={this.props.patientlist} onBillableKPIDateChange={this.onBillableKPIDateChange} dataAnalytics={this.props.dataAnalytics} handleResetBillableKPI= {this.handleResetBillableKPI} handleBillableReportTypeChange={this.handleBillableReportTypeChange} ByWeekOrMonthList={this.state.ByWeekOrMonthList}
                      masterTagsForAll={this.props.masterTagsForAll} isExcludeTagHandler = {this.isExcludeTagHandler} handleTagChange={this.handleTagChange} billableAppointmentType={this.props.billableAppointmentType} />}
                {this.state.billableActionName === 'Cancelled Hours' && 
                    <KPICancelledHours FromBillableHoursDate={this.state.FromBillableHoursDate} ToBillableHoursDate={this.state.ToBillableHoursDate} handleBillableChange={this.handleBillableChange} userLocationList={this.props.userLocationList} 
                      masterInsuranceCompanies={this.props.masterInsuranceCompanies} appointmentType={this.props.appointmentType} allStaffs={this.props.allStaffs}
                      patientlist={this.props.patientlist} onBillableKPIDateChange={this.onBillableKPIDateChange} dataAnalytics={this.props.dataAnalytics} handleResetBillableKPI= {this.handleResetBillableKPI}  handleBillableReportTypeChange={this.handleBillableReportTypeChange} ByWeekOrMonthList={this.state.ByWeekOrMonthList} 
                      masterCancelType = {this.props.masterCancelType} masterTagsForAll={this.props.masterTagsForAll} isExcludeTagHandler = {this.isExcludeTagHandler} handleTagChange={this.handleTagChange} billableAppointmentType={this.props.billableAppointmentType}/>}
                {this.state.billableActionName === 'Percentage of Cancellations' && 
                    <KPIPercentageOfCancellation FromBillableHoursDate={this.state.FromBillableHoursDate} ToBillableHoursDate={this.state.ToBillableHoursDate} handleBillableChange={this.handleBillableChange} userLocationList={this.props.userLocationList} 
                      masterInsuranceCompanies={this.props.masterInsuranceCompanies} appointmentType={this.props.appointmentType} allStaffs={this.props.allStaffs}
                      patientlist={this.props.patientlist} onBillableKPIDateChange={this.onBillableKPIDateChange} dataAnalytics={this.props.dataAnalytics} handleResetBillableKPI= {this.handleResetBillableKPI} 
                      masterTagsForAll={this.props.masterTagsForAll} isExcludeTagHandler = {this.isExcludeTagHandler} handleTagChange={this.handleTagChange} billableAppointmentType={this.props.billableAppointmentType}/> }
                {this.state.billableActionName === 'All Hours' && 
                    <KPIScheduledHours FromBillableHoursDate={this.state.FromBillableHoursDate} ToBillableHoursDate={this.state.ToBillableHoursDate} handleBillableChange={this.handleBillableChange} userLocationList={this.props.userLocationList} 
                      masterInsuranceCompanies={this.props.masterInsuranceCompanies} appointmentType={this.props.appointmentType} allStaffs={this.props.allStaffs}
                      patientlist={this.props.patientlist} onBillableKPIDateChange={this.onBillableKPIDateChange} dataAnalytics={this.props.dataAnalytics} handleResetBillableKPI= {this.handleResetBillableKPI} 
                      checkBillableAllHoursStatus = {this.checkBillableAllHoursStatus} masterTagsForAll={this.props.masterTagsForAll} isExcludeTagHandler = {this.isExcludeTagHandler} handleTagChange={this.handleTagChange} billableAppointmentType={this.props.billableAppointmentType}/> }
              </KPIPanelToolTip>
            </div>
          </div> 

          
            <div className="row dashboardchart">
              <div className="col-md-12 mb-30">
                {this.props.FinancialKPI_loading ?
                  <div className="full_loader top0">
                    <div className="small-loader">
                      <img src={SmallLoader} alt="" />
                    </div>
                  </div>
                  : null}
                <FinancialKPIPanelToolTip
                  financialKPItitle={this.state.financialKPItitle}
                  financialKPIsubtitle= {this.state.financialKPIsubtitle}
                  righticon={true}
                  handlechangeFinancialKPI= {this.handlechangeFinancialKPI}>
                    {this.state.financialActionName === 'Open A/R Expected Amounts' &&
                      <FinancialKPI_OPENAREXPECTEDAMOUNTS FromFinancialDate={this.state.FromFinancialDate} ToFinancialDate={this.state.ToFinancialDate} handleFinancialChange={this.handleFinancialChange} masterInsuranceCompanies={this.props.masterInsuranceCompanies} 
                        patientlist={this.props.patientlist} onFinancialKPIDateChange={this.onFinancialKPIDateChange} financialDataAnalytics={this.props.financialDataAnalytics} handleResetFinancialKPI= {this.handleResetFinancialKPI} checkFinancialExcludePR={this.checkFinancialExcludePR} 
                        userLocationList={this.props.userLocationList}/>}
                    {this.state.financialActionName === 'Open Claims by Status' &&
                      <FinancialKPI_OPENCLAIMSBYSTATUS FromFinancialDate={this.state.FromFinancialDate} ToFinancialDate={this.state.ToFinancialDate} handleFinancialChange={this.handleFinancialChange} masterInsuranceCompanies={this.props.masterInsuranceCompanies} 
                        patientlist={this.props.patientlist} onFinancialKPIDateChange={this.onFinancialKPIDateChange} financialDataAnalytics={this.props.financialDataAnalytics} handleResetFinancialKPI= {this.handleResetFinancialKPI} userLocationList={this.props.userLocationList}/>}
                    {this.state.financialActionName === 'Payments Collected' &&
                      <FinancialKPI_PAYMENTSCOLLECTED FromFinancialDate={this.state.FromFinancialDate} ToFinancialDate={this.state.ToFinancialDate} handleFinancialChange={this.handleFinancialChange} masterInsuranceCompanies={this.props.masterInsuranceCompanies} handleIsDepositeDate={this.handleIsDepositeDate}
                        patientlist={this.props.patientlist} onFinancialKPIDateChange={this.onFinancialKPIDateChange} financialDataAnalytics={this.props.financialDataAnalytics} handleResetFinancialKPI= {this.handleResetFinancialKPI} handleFinancialReportTypeChange={this.handleFinancialReportTypeChange} ByWeekOrMonthList={this.state.ByWeekOrMonthList} 
                        userLocationList={this.props.userLocationList}/>}
                    {this.state.financialActionName === 'Collection Rate' &&                       
                        <FinancialKPI_COLLECTIONRATE FromFinancialDate={this.state.FromFinancialDate} ToFinancialDate={this.state.ToFinancialDate} handleFinancialChange={this.handleFinancialChange} masterInsuranceCompanies={this.props.masterInsuranceCompanies} 
                        patientlist={this.props.patientlist} onFinancialKPIDateChange={this.onFinancialKPIDateChange} financialDataAnalytics={this.props.financialDataAnalytics} handleResetFinancialKPI= {this.handleResetFinancialKPI} checkFinancialExcludePR={this.checkFinancialExcludePR} 
                        userLocationList={this.props.userLocationList}/>}
                    {this.state.financialActionName === 'Staff Billing' &&
                      <FinancialKPI_STAFFBILLING FromFinancialDate={this.state.FromFinancialDate} ToFinancialDate={this.state.ToFinancialDate} handleFinancialChange={this.handleFinancialChange} masterInsuranceCompanies={this.props.masterInsuranceCompanies} 
                        patientlist={this.props.patientlist} onFinancialKPIDateChange={this.onFinancialKPIDateChange} financialDataAnalytics={this.props.financialDataAnalytics} handleResetFinancialKPI= {this.handleResetFinancialKPI} 
                        allStaffs={this.props.allStaffsActiveAndInactive} userLocationList={this.props.userLocationList}/>}
                    {this.state.financialActionName === 'Amount Billed' &&
                      <FinancialKPI_AMOUNTBILLED FromFinancialDate={this.state.FromFinancialDate} ToFinancialDate={this.state.ToFinancialDate} handleFinancialChange={this.handleFinancialChange} masterInsuranceCompanies={this.props.masterInsuranceCompanies} 
                        patientlist={this.props.patientlist} onFinancialKPIDateChange={this.onFinancialKPIDateChange} financialDataAnalytics={this.props.financialDataAnalytics} handleResetFinancialKPI= {this.handleResetFinancialKPI} handleFinancialReportTypeChange={this.handleFinancialReportTypeChange} ByWeekOrMonthList={this.state.ByWeekOrMonthList}  
                        checkFinancialDisplayByAllowedAmount={this.checkFinancialDisplayByAllowedAmount} checkFinancialSearchBySubmittedDates={this.checkFinancialSearchBySubmittedDates} userLocationList={this.props.userLocationList}/>}
                    {this.state.financialActionName === 'Profit Analysis' &&
                      <FinancialKPI_PROFITANALYSIS FromFinancialDate={this.state.FromFinancialDate} ToFinancialDate={this.state.ToFinancialDate} handleFinancialChange={this.handleFinancialChange} masterInsuranceCompanies={this.props.masterInsuranceCompanies} 
                        patientlist={this.props.patientlist} onFinancialKPIDateChange={this.onFinancialKPIDateChange} financialDataAnalytics={this.props.financialDataAnalytics} handleResetFinancialKPI= {this.handleResetFinancialKPI} 
                        allStaffs={this.props.allStaffsActiveAndInactive} checkFinancialIncludeMileage={this.checkFinancialIncludeMileage} checkFinancialIncludeDrivetime={this.checkFinancialIncludeDrivetime} checkFinancialIncludeBreak={this.checkFinancialIncludeBreak} 
                        generateFinancialKPIProfitAnalysis= {this.generateFinancialKPIProfitAnalysis} userLocationList={this.props.userLocationList}/>}
                </FinancialKPIPanelToolTip>              
              </div>
            </div> 

        <div className="row dashboardchart">
          <div className="col-md-12">
            {this.props.BottonPanel_loading ?
              <div className="full_loader top0">
                <div className="small-loader">
                  <img src={SmallLoader} alt="" />
                </div>
              </div>
              : null}

            <BottonPanelToolTip
              extensionGetter = {this.extensionGetter}
              title="Appointments"
              righticon={false}>
              {this.props.OrganizationEncounter && !isEmptyObject(this.props.OrganizationEncounter) ?
                <EncounterTable extension={this.state.extension} OrganizationEncounter={this.props.OrganizationEncounter} />
                :
                <EncounterTable OrganizationEncounter={null} />
              }
            </BottonPanelToolTip>
          </div>
        </div>
      </div>
    );
  }


  renderStaffDashboard() {
    return (
      <div>
        {/* <IconBoxes /> */}
        {/* <div className="row dashboardchart"> */}
        {/* <div className="col-md-6 mb-30">
            <Panel
              title="Total Earns"
              righticon={true}
            >
              <SimpleAreaChart />
            </Panel>
          </div> */}

        {/* <div className="col-md-6 mb-30">
            <Panel
              title="Total Sales"
              righticon={true}
            >
              <SimpleLineChart />
            </Panel>
          </div>
        </div> */}
        {/* <div className="row dashboardchart">
          <div className="col-md-12 mb-30">
            {this.props.RightPanel_loading ?
              <div className="full_loader top0">
                <div className="small-loader">
                  <img src={SmallLoader} alt="" />
                </div>
              </div>
              : null}

            <RightPanelToolTip
              title="Authorizations"
              righticon={true}>
              <AuthorizationTable OrganizationAuthorization={this.props.OrganizationAuthorization} />
            </RightPanelToolTip>
          </div>
        </div> */}
         {/* {this.props.viewStaffAndClientOnDashboadPermission === true && this.props.OrganizationEncounter && !isEmptyObject(this.props.OrganizationEncounter) ? */}
         {this.props.viewStaffAndClientOnDashboadPermission === true  &&
          <TopBoxes TotalClientCount={this.props.TotalClientCount} TotalStaffCount={this.props.TotalStaffCount} TotalRevenue={null} OnlineUsers={this.props.OnlineUsers} />          
        }
        <div className="row dashboardchart">              
          {this.props.authorizationPermission ?
            <div className="col-md-6 mb-30">
              {this.props.RightPanel_loading ?
                <div className="full_loader top0">
                  <div className="small-loader">
                    <img src={SmallLoader} alt="" />
                  </div>
                </div>
                : null}

              <RightPanelToolTip
                extensionGetter={this.extensionGetter}
                downLoadAuthDocs={this.ExportCSVOrExcelOrganizationAuthorizationsDocuments}
                title="Authorizations"
                righticon={false}>
                <AuthorizationTable SendQueryparams = {this. ExportCSVOrExcelOrganizationAuthorizationDocumentsParamGetter} OrganizationAuthorization={this.props.OrganizationAuthorization} viewTeamClientsOnlyPermission={this.props.viewTeamClientsOnlyPermission} />
              </RightPanelToolTip>
            </div> : null}
          {this.props.staffDocumentPermission ?      
            <div className="col-md-6 mb-30">
              {this.props.LeftPanel_loading ?
                <div className="full_loader top0">
                  <div className="small-loader">
                    <img src={SmallLoader} alt="" />
                  </div>
                </div>
                : null}

              <LeftPanelToolTip
                title="Staff Documents"
                extensionGetter={this.extensionGetter}
                downLoadStaffDocs={this.ExportCSVOrExcelOrganizationStaffDocuments}
                downLoadNonAdminStaffDocs = {this.ExportCSVOrExcelStaffNonAdminDocuments}
                righticon={false}>
                <StaffDocuemntsTable SendQueryparams = {this.ExportCSVOrExcelOrganizationClientDocumentsParamGetter} StaffDocmuents={this.props.StaffDocmuents} />
              </LeftPanelToolTip>
            </div> : null}

            {this.props.clientDocumentPermission ?      
            <div className="col-md-6 mb-30">
              {this.props.LeftPanel_loading ?
                <div className="full_loader top0">
                  <div className="small-loader">
                    <img src={SmallLoader} alt="" />
                  </div>
                </div>
                : null}

              <LeftPanelToolTip
                title="Client Documents"
                extensionGetter={this.extensionGetter}
                downLoadClientDocs={this.ExportCSVOrExcelOrganizationClientDocuments}
                downLoadNonAdminClientDocs = {this.ExportCSVOrExcelClientNonAdminDocuments}
                righticon={false}>
                <ClientDocuemntsTable SendQueryparams = {this.ExportCSVOrExcelOrganizationClientDocumentsParamGetter} ClientDocuments={this.props.ClientDocuments}  viewTeamClientsOnlyPermission={this.props.viewTeamClientsOnlyPermission} />
              </LeftPanelToolTip>
            </div> : null}
            
        </div>

        {this.props.OARejectionsOnDashboadPermission === true ? 
        <div className="row dashboardchart">          
            <div className="col-md-12 mb-30">
              {this.props.OAResponse_loading ?
                <div className="full_loader top0">
                  <div className="small-loader">
                    <img src={SmallLoader} alt="" />
                  </div>
                </div>
                : null}
              <OAResponsePanelToolTip
                title="Clearinghouse Rejections"
                righticon={false}
                FromOAResponsesDate = {this.state.FromOAResponsesDate}
                ToOAResponsesDate = {this.state.ToOAResponsesDate}>
                 {this.props.OrganizationOAResponses && !isEmptyObject(this.props.OrganizationOAResponses) ?
                      <OAResponses FromOAResponsesDate={this.state.FromOAResponsesDate} ToOAResponsesDate={this.state.ToOAResponsesDate}                       
                      onOAResponseDateChange={this.onOAResponseDateChange}  handleResetOAResponse= {this.handleResetOAResponse} 
                      OrganizationOAResponses={this.props.OrganizationOAResponses}  />
                    :
                      <OAResponses FromOAResponsesDate={this.state.FromOAResponsesDate} ToOAResponsesDate={this.state.ToOAResponsesDate}                       
                          onOAResponseDateChange={this.onOAResponseDateChange}  handleResetOAResponse= {this.handleResetOAResponse} 
                          OrganizationOAResponses={null} />
                  } 
              </OAResponsePanelToolTip>
            </div>
          </div> : null}

          {this.props.PayerDenialsOnDashboadPermission === true ? 
          <div className="row dashboardchart">          
              <div className="col-md-12 mb-30">
                {this.props.PayerResponse_loading ?
                  <div className="full_loader top0">
                    <div className="small-loader">
                      <img src={SmallLoader} alt="" />
                    </div>
                  </div>
                  : null}
                <PayerResponsePanelToolTip
                  title="Payer Denials"
                  righticon={false}
                  FromPayerResponsesDate = {this.state.FromPayerResponsesDate}
                  ToPayerResponsesDate = {this.state.ToPayerResponsesDate}
                  >
                  {this.props.OrganizationPayerResponses && !isEmptyObject(this.props.OrganizationPayerResponses) ?
                        <PayerResponses FromPayerResponsesDate={this.state.FromPayerResponsesDate} ToPayerResponsesDate={this.state.ToPayerResponsesDate}                       
                        onPayerResponseDateChange={this.onPayerResponseDateChange}  handleResetPayerResponse= {this.handleResetPayerResponse} 
                        OrganizationPayerResponses={this.props.OrganizationPayerResponses}  />
                      :
                        <PayerResponses FromPayerResponsesDate={this.state.FromPayerResponsesDate} ToPayerResponsesDate={this.state.ToPayerResponsesDate}                       
                            onPayerResponseDateChange={this.onPayerResponseDateChange}  handleResetPayerResponse= {this.handleResetPayerResponse} 
                            OrganizationPayerResponses={null} />
                    } 
                </PayerResponsePanelToolTip>
              </div>
            </div> : null}

        {this.props.billableKPIOnDashboadPermission === true ? 
          <div className="row dashboardchart">          
            <div className="col-md-12 mb-30">
              {this.props.BillableKPI_loading ?
                <div className="full_loader top0">
                  <div className="small-loader">
                    <img src={SmallLoader} alt="" />
                  </div>
                </div>
                : null}
              <KPIPanelToolTip
                billableKPItitle={this.state.billableKPItitle}
                billableKPIsubtitle= {this.state.billableKPIsubtitle}
                righticon={true}
                handleChangeBillableKPI= {this.handleChangeBillableKPI}>                
                {this.state.billableActionName === 'Billable Hours' && 
                    <KPIBillableHours FromBillableHoursDate={this.state.FromBillableHoursDate} ToBillableHoursDate={this.state.ToBillableHoursDate} handleBillableChange={this.handleBillableChange} userLocationList={this.props.userLocationList} 
                      masterInsuranceCompanies={this.props.masterInsuranceCompanies} billableAppointmentType={this.props.billableAppointmentType} allStaffs={this.props.allStaffs}
                      patientlist={this.props.patientlist} onBillableKPIDateChange={this.onBillableKPIDateChange} dataAnalytics={this.props.dataAnalytics} handleResetBillableKPI= {this.handleResetBillableKPI} handleBillableReportTypeChange={this.handleBillableReportTypeChange} ByWeekOrMonthList={this.state.ByWeekOrMonthList}  
                      masterTagsForAll={this.props.masterTagsForAll} isExcludeTagHandler = {this.isExcludeTagHandler} handleTagChange={this.handleTagChange}/>}
                {this.state.billableActionName === 'Non-Billable Hours' && 
                    <KPINonBillableHours FromBillableHoursDate={this.state.FromBillableHoursDate} ToBillableHoursDate={this.state.ToBillableHoursDate} handleBillableChange={this.handleBillableChange} userLocationList={this.props.userLocationList} 
                      masterInsuranceCompanies={this.props.masterInsuranceCompanies} nonBillableAppointmentType={this.props.nonBillableAppointmentType} allStaffs={this.props.allStaffs}
                      patientlist={this.props.patientlist} onBillableKPIDateChange={this.onBillableKPIDateChange} dataAnalytics={this.props.dataAnalytics} handleResetBillableKPI= {this.handleResetBillableKPI} handleBillableReportTypeChange={this.handleBillableReportTypeChange} ByWeekOrMonthList={this.state.ByWeekOrMonthList}  
                      masterTagsForAll={this.props.masterTagsForAll} isExcludeTagHandler = {this.isExcludeTagHandler} handleTagChange={this.handleTagChange}/>}
                {this.state.billableActionName === 'Cancelled Hours' && 
                    <KPICancelledHours FromBillableHoursDate={this.state.FromBillableHoursDate} ToBillableHoursDate={this.state.ToBillableHoursDate} handleBillableChange={this.handleBillableChange} userLocationList={this.props.userLocationList} 
                      masterInsuranceCompanies={this.props.masterInsuranceCompanies} appointmentType={this.props.appointmentType} allStaffs={this.props.allStaffs}
                      patientlist={this.props.patientlist} onBillableKPIDateChange={this.onBillableKPIDateChange} dataAnalytics={this.props.dataAnalytics} handleResetBillableKPI= {this.handleResetBillableKPI} handleBillableReportTypeChange={this.handleBillableReportTypeChange} ByWeekOrMonthList={this.state.ByWeekOrMonthList}  
                      masterCancelType = {this.props.masterCancelType} masterTagsForAll={this.props.masterTagsForAll} isExcludeTagHandler = {this.isExcludeTagHandler} handleTagChange={this.handleTagChange}/>}
                {this.state.billableActionName === 'Percentage of Cancellations' && 
                    <KPIPercentageOfCancellation FromBillableHoursDate={this.state.FromBillableHoursDate} ToBillableHoursDate={this.state.ToBillableHoursDate} handleBillableChange={this.handleBillableChange} userLocationList={this.props.userLocationList} 
                      masterInsuranceCompanies={this.props.masterInsuranceCompanies} appointmentType={this.props.appointmentType} allStaffs={this.props.allStaffs}
                      patientlist={this.props.patientlist} onBillableKPIDateChange={this.onBillableKPIDateChange} dataAnalytics={this.props.dataAnalytics} handleResetBillableKPI= {this.handleResetBillableKPI} masterTagsForAll={this.props.masterTagsForAll} isExcludeTagHandler = {this.isExcludeTagHandler} handleTagChange={this.handleTagChange}/> }
                {this.state.billableActionName === 'All Hours' && 
                    <KPIScheduledHours FromBillableHoursDate={this.state.FromBillableHoursDate} ToBillableHoursDate={this.state.ToBillableHoursDate} handleBillableChange={this.handleBillableChange} userLocationList={this.props.userLocationList} 
                      masterInsuranceCompanies={this.props.masterInsuranceCompanies} appointmentType={this.props.appointmentType} allStaffs={this.props.allStaffs}
                      patientlist={this.props.patientlist} onBillableKPIDateChange={this.onBillableKPIDateChange} dataAnalytics={this.props.dataAnalytics} handleResetBillableKPI= {this.handleResetBillableKPI} 
                      checkBillableAllHoursStatus = {this.checkBillableAllHoursStatus} masterTagsForAll={this.props.masterTagsForAll} isExcludeTagHandler = {this.isExcludeTagHandler} handleTagChange={this.handleTagChange}/> }
              </KPIPanelToolTip>
            </div>
          </div> : null}

          {this.props.financialSummaryKPIOnDashboadPermission === true ?
            <div className="row dashboardchart">          
              <div className="col-md-12 mb-30">
                {this.props.FinancialKPI_loading ?
                  <div className="full_loader top0">
                    <div className="small-loader">
                      <img src={SmallLoader} alt="" />
                    </div>
                  </div>
                  : null}
                <FinancialKPIPanelToolTip
                  financialKPItitle={this.state.financialKPItitle}
                  financialKPIsubtitle= {this.state.financialKPIsubtitle}
                  righticon={true}
                  handlechangeFinancialKPI= {this.handlechangeFinancialKPI}>
                    {this.state.financialActionName === 'Open A/R Expected Amounts' &&
                      <FinancialKPI_OPENAREXPECTEDAMOUNTS FromFinancialDate={this.state.FromFinancialDate} ToFinancialDate={this.state.ToFinancialDate} handleFinancialChange={this.handleFinancialChange} masterInsuranceCompanies={this.props.masterInsuranceCompanies} 
                        patientlist={this.props.patientlist} onFinancialKPIDateChange={this.onFinancialKPIDateChange} financialDataAnalytics={this.props.financialDataAnalytics} handleResetFinancialKPI= {this.handleResetFinancialKPI} checkFinancialExcludePR={this.checkFinancialExcludePR} 
                        userLocationList={this.props.userLocationList}/>}
                     {this.state.financialActionName === 'Open Claims by Status' &&
                      <FinancialKPI_OPENCLAIMSBYSTATUS FromFinancialDate={this.state.FromFinancialDate} ToFinancialDate={this.state.ToFinancialDate} handleFinancialChange={this.handleFinancialChange} masterInsuranceCompanies={this.props.masterInsuranceCompanies} 
                        patientlist={this.props.patientlist} onFinancialKPIDateChange={this.onFinancialKPIDateChange} financialDataAnalytics={this.props.financialDataAnalytics} handleResetFinancialKPI= {this.handleResetFinancialKPI} userLocationList={this.props.userLocationList}/>}
                    {this.state.financialActionName === 'Payments Collected' &&
                      <FinancialKPI_PAYMENTSCOLLECTED FromFinancialDate={this.state.FromFinancialDate} ToFinancialDate={this.state.ToFinancialDate} handleFinancialChange={this.handleFinancialChange} masterInsuranceCompanies={this.props.masterInsuranceCompanies} 
                        patientlist={this.props.patientlist} onFinancialKPIDateChange={this.onFinancialKPIDateChange} financialDataAnalytics={this.props.financialDataAnalytics} handleResetFinancialKPI= {this.handleResetFinancialKPI} handleFinancialReportTypeChange={this.handleFinancialReportTypeChange} ByWeekOrMonthList={this.state.ByWeekOrMonthList}  
                        userLocationList={this.props.userLocationList}/>}
                    {this.state.financialActionName === 'Collection Rate' &&                       
                        <FinancialKPI_COLLECTIONRATE FromFinancialDate={this.state.FromFinancialDate} ToFinancialDate={this.state.ToFinancialDate} handleFinancialChange={this.handleFinancialChange} masterInsuranceCompanies={this.props.masterInsuranceCompanies} 
                        patientlist={this.props.patientlist} onFinancialKPIDateChange={this.onFinancialKPIDateChange} financialDataAnalytics={this.props.financialDataAnalytics} handleResetFinancialKPI= {this.handleResetFinancialKPI} checkFinancialExcludePR={this.checkFinancialExcludePR} userLocationList={this.props.userLocationList}/>}
                    {this.state.financialActionName === 'Staff Billing' &&
                      <FinancialKPI_STAFFBILLING FromFinancialDate={this.state.FromFinancialDate} ToFinancialDate={this.state.ToFinancialDate} handleFinancialChange={this.handleFinancialChange} masterInsuranceCompanies={this.props.masterInsuranceCompanies} 
                        patientlist={this.props.patientlist} onFinancialKPIDateChange={this.onFinancialKPIDateChange} financialDataAnalytics={this.props.financialDataAnalytics} handleResetFinancialKPI= {this.handleResetFinancialKPI} 
                        allStaffs={this.props.allStaffsActiveAndInactive} userLocationList={this.props.userLocationList}/>}
                    {this.state.financialActionName === 'Amount Billed' &&
                      <FinancialKPI_AMOUNTBILLED FromFinancialDate={this.state.FromFinancialDate} ToFinancialDate={this.state.ToFinancialDate} handleFinancialChange={this.handleFinancialChange} masterInsuranceCompanies={this.props.masterInsuranceCompanies} 
                        patientlist={this.props.patientlist} onFinancialKPIDateChange={this.onFinancialKPIDateChange} financialDataAnalytics={this.props.financialDataAnalytics} handleResetFinancialKPI= {this.handleResetFinancialKPI} handleFinancialReportTypeChange={this.handleFinancialReportTypeChange} ByWeekOrMonthList={this.state.ByWeekOrMonthList}  
                        checkFinancialDisplayByAllowedAmount={this.checkFinancialDisplayByAllowedAmount} checkFinancialSearchBySubmittedDates={this.checkFinancialSearchBySubmittedDates} userLocationList={this.props.userLocationList}/>}
                    {this.state.financialActionName === 'Profit Analysis' &&
                      <FinancialKPI_PROFITANALYSIS FromFinancialDate={this.state.FromFinancialDate} ToFinancialDate={this.state.ToFinancialDate} handleFinancialChange={this.handleFinancialChange} masterInsuranceCompanies={this.props.masterInsuranceCompanies} 
                        patientlist={this.props.patientlist} onFinancialKPIDateChange={this.onFinancialKPIDateChange} financialDataAnalytics={this.props.financialDataAnalytics} handleResetFinancialKPI= {this.handleResetFinancialKPI} 
                        allStaffs={this.props.allStaffsActiveAndInactive} checkFinancialIncludeMileage={this.checkFinancialIncludeMileage} checkFinancialIncludeDrivetime={this.checkFinancialIncludeDrivetime} checkFinancialIncludeBreak={this.checkFinancialIncludeBreak} 
                        generateFinancialKPIProfitAnalysis= {this.generateFinancialKPIProfitAnalysis} userLocationList={this.props.userLocationList}/>}
                </FinancialKPIPanelToolTip>              
              </div>
            </div> : null}
         
        {this.props.appointmentsPermission === true ?
          <div className="row dashboardchart">
            <div className="col-md-12 mb-30">
              {this.props.BottonPanel_loading ?
                <div className="full_loader top0">
                  <div className="small-loader">
                    <img src={SmallLoader} alt="" />
                  </div>
                </div>
                : null}
              <BottonPanelToolTip
                extensionGetter = {this.extensionGetter}
                title="Appointments"
                righticon={false}>
                <StaffEncounterTable extension={this.state.extension} StaffEncounters={this.props.StaffEncounters} />
              </BottonPanelToolTip>
            </div>
          </div> : null}
      </div>
    );
  }


  render() {
    return (
      <div>
        <ReactCSSTransitionGroup
          transitionName="toggle"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={300}>
          {this.state.showMessage && this.props.passwordExpiryMessage ?
            <div className={'alert ' + this.props.passwordExpiryColorCode + ' update-pwd'}>
              {this.props.passwordExpiryMessage}
              <i onClick={this.hideMessageClick} className="fa fa-times" aria-hidden="true"></i>
            </div>
            : null}
        </ReactCSSTransitionGroup>
        {this.props.loginUserInfo.userRoles.userType === 'ADMIN' ?          
          this.renderAdminDashboard1()
          :
          this.renderStaffDashboard()
        }
      </div>
    );
  }
}
StaffDashBoard = reduxForm({
  form: 'StaffDashBoardForm',
})(StaffDashBoard);
// const selectorReadyToBillForm = formValueSelector('ReadyToBillForm');

const mapStateToProps = (state) => {

  let locationArr = [];
  if (state.login.userLocationList) {
    locationArr = (state.login.userLocationList).map((obj) => {
      return (
        {
          id: obj.id,
          value: obj.locationName,
        }
      );
    });
  }

  let patients = [];
  if (state.staff_dashboard.patientList && state.staff_dashboard.patientList.data) {
    patients = state.staff_dashboard.patientList.data.patients;
  }

  // Start For Role Permission  
  let dashboardScreenPermission = [];
  let userScreenPermission = [];
  if (state.login.userPermission) {
    let dashboardModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'DASHBOARD');
    dashboardScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.moduleId === dashboardModulePermission[0].moduleId);
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'CLIENT');
    userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.moduleId === userModulePermission[0].moduleId);

  }
  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3 && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission
 
  let authorizationPermission = hasDefaultAccess ? true : dashboardScreenPermission && dashboardScreenPermission.filter((obj) => obj.screenKey === 'DASHBOARD_VIEW_AUTHORIZATION_ON_DASHBOARD')[0] ? dashboardScreenPermission.filter((obj) => obj.screenKey === 'DASHBOARD_VIEW_AUTHORIZATION_ON_DASHBOARD')[0].permission : false;
  let staffDocumentPermission = hasDefaultAccess ? true : dashboardScreenPermission && dashboardScreenPermission.filter((obj) => obj.screenKey === 'DASHBOARD_VIEW_STAFF_DOCUMENTS_ON_DASHBOARD')[0] ? dashboardScreenPermission.filter((obj) => obj.screenKey === 'DASHBOARD_VIEW_STAFF_DOCUMENTS_ON_DASHBOARD')[0].permission : false;
  let clientDocumentPermission = hasDefaultAccess ? true : dashboardScreenPermission && dashboardScreenPermission.filter((obj) => obj.screenKey === 'DASHBOARD_VIEW_CLIENT_DOCUMENTS_ON_DASHBOARD')[0] ? dashboardScreenPermission.filter((obj) => obj.screenKey === 'DASHBOARD_VIEW_CLIENT_DOCUMENTS_ON_DASHBOARD')[0].permission : false;
  let appointmentsPermission = hasDefaultAccess ? true : dashboardScreenPermission && dashboardScreenPermission.filter((obj) => obj.screenKey === 'DASHBOARD_VIEW_APPOINTMENTS_ON_DASHBOARD')[0] ? dashboardScreenPermission.filter((obj) => obj.screenKey === 'DASHBOARD_VIEW_APPOINTMENTS_ON_DASHBOARD')[0].permission : false;

  let viewTeamClientsOnlyPermission = hasDefaultAccess ? false : userScreenPermission && userScreenPermission.filter((obj) => obj.screenKey === 'VIEW_TEAM_CLIENTS_ONLY')[0] ? userScreenPermission.filter((obj) => obj.screenKey === 'VIEW_TEAM_CLIENTS_ONLY')[0].permission : false;

  let OARejectionsOnDashboadPermission = hasDefaultAccess ? true : dashboardScreenPermission && dashboardScreenPermission.filter((obj) => obj.screenKey === 'DASHBOARD_VIEW_OA_REJECTIONS_ON_DASHBOARD')[0] ? dashboardScreenPermission.filter((obj) => obj.screenKey === 'DASHBOARD_VIEW_OA_REJECTIONS_ON_DASHBOARD')[0].permission : false;
  let billableKPIOnDashboadPermission = hasDefaultAccess ? true : dashboardScreenPermission && dashboardScreenPermission.filter((obj) => obj.screenKey === 'DASHBOARD_VIEW_TOTAL_HOURS_CHART_ON_DASHBOARD')[0] ? dashboardScreenPermission.filter((obj) => obj.screenKey === 'DASHBOARD_VIEW_TOTAL_HOURS_CHART_ON_DASHBOARD')[0].permission : false;
  let financialSummaryKPIOnDashboadPermission = hasDefaultAccess ? true : dashboardScreenPermission && dashboardScreenPermission.filter((obj) => obj.screenKey === 'DASHBOARD_VIEW_FINANCIAL_SUMMARY_ON_DASHBOARD')[0] ? dashboardScreenPermission.filter((obj) => obj.screenKey === 'DASHBOARD_VIEW_FINANCIAL_SUMMARY_ON_DASHBOARD')[0].permission : false;

  let viewStaffAndClientOnDashboadPermission = hasDefaultAccess ? true : dashboardScreenPermission && dashboardScreenPermission.filter((obj) => obj.screenKey === 'DASHBOARD_VIEW_STAFF_AND_CLIENT_ON_DASHBOARD')[0] ? dashboardScreenPermission.filter((obj) => obj.screenKey === 'DASHBOARD_VIEW_STAFF_AND_CLIENT_ON_DASHBOARD')[0].permission : false;

  let PayerDenialsOnDashboadPermission = hasDefaultAccess ? true : dashboardScreenPermission && dashboardScreenPermission.filter((obj) => obj.screenKey === 'DASHBOARD_VIEW_PAYER_DENIALS_ON_DASHBOARD')[0] ? dashboardScreenPermission.filter((obj) => obj.screenKey === 'DASHBOARD_VIEW_PAYER_DENIALS_ON_DASHBOARD')[0].permission : false;


  // End For Role Permission

  //console.log('state.staff_dashboard............',state.staff_dashboard)
  // console.log('state.staff_dashboard ? state.staff_dashboard.OrganizationStaffDocuments............',state.staff_dashboard ? state.staff_dashboard.OrganizationStaffDocuments : {})
  // console.log('state.staff_dashboard.........', state.staff_dashboard && state.staff_dashboard.DashboardData.data);
  return {
    loginUserInfo: state.login.loginUserInfo,
    TotalClientCount: state.staff_dashboard && state.staff_dashboard.DashboardData.data ? state.staff_dashboard.DashboardData.data.organizationTotalClients : 0,
    TotalStaffCount: state.staff_dashboard && state.staff_dashboard.DashboardData.data ? state.staff_dashboard.DashboardData.data.organizationTotalStaff : 0,
    //TotalRevenue: state.staff_dashboard && state.staff_dashboard.DashboardData.data ? state.staff_dashboard.DashboardData.data.organizationTotalRevenu.totalRevenue : 0,
    OnlineUsers: state.staff_dashboard && state.staff_dashboard.DashboardData.data ? state.staff_dashboard.DashboardData.data.onlineUser : 0,
    OrganizationAuthorization: state.staff_dashboard ? state.staff_dashboard.OrganizationAuthorization : {},
    OrganizationEncounter: state.staff_dashboard ? state.staff_dashboard.OrganizationEncounter : {},
    StaffEncounters: state.staff_dashboard ? state.staff_dashboard.StaffEncounters : {},
    OrganizationStaffDocmuents: state.staff_dashboard ? state.staff_dashboard.OrganizationStaffDocuments : {},
    OrganizationClientDocmuents: state.staff_dashboard ? state.staff_dashboard.OrganizationClientDocuments : {},
    StaffDocmuents: state.staff_dashboard ? state.staff_dashboard.StaffDocuments : {},
    ClientDocuments: state.staff_dashboard ? state.staff_dashboard.ClientDocuments : {},
    LeftPanel_loading: state.staff_dashboard.LeftPanel_loading,
    RightPanel_loading: state.staff_dashboard.RightPanel_loading,
    BottonPanel_loading: state.staff_dashboard.BottonPanel_loading,
    clientStatusChart: state.staff_dashboard && state.staff_dashboard.DashboardData.data ? state.staff_dashboard.DashboardData.data.clientStatusChart : [],
    passwordExpiryMessage: state.staff_dashboard && state.staff_dashboard.passwordExpiryMessage ? state.staff_dashboard.passwordExpiryMessage : '',
    passwordExpiryColorCode: state.staff_dashboard && state.staff_dashboard.passwordExpiryColorCode ? state.staff_dashboard.passwordExpiryColorCode : '',    
    authorizationPermission: authorizationPermission,
    staffDocumentPermission: staffDocumentPermission,    
    clientDocumentPermission: clientDocumentPermission,
    viewTeamClientsOnlyPermission: viewTeamClientsOnlyPermission,
    userLocationList: locationArr,
    allStaffs : state.staff_dashboard.master_data ? state.staff_dashboard.master_data.allStaffs : [],
    allStaffsActiveAndInactive : state.staff_dashboard.master_data ? state.staff_dashboard.master_data.allStaffsActiveAndInactive : [],
    billableAppointmentType:  state.staff_dashboard.master_data ? state.staff_dashboard.master_data.billableAppointmentType : [],   
    nonBillableAppointmentType:  state.staff_dashboard.master_data ? state.staff_dashboard.master_data.nonBillableAppointmentType : [],       
    appointmentType:  state.staff_dashboard.master_data ? state.staff_dashboard.master_data.appointmentType : [],       
    patientlist: patients,
    masterInsuranceCompanies: state.staff_dashboard.master_data ? state.staff_dashboard.master_data.insuranceCompanies : [],   
    masterTagsForAll : state.staff_dashboard.master_data ? state.staff_dashboard.master_data.masterTagsforAll : [],
    dataAnalytics: state.staff_dashboard ? state.staff_dashboard.OrganizationBillableHoursGraph : {},
    BillableKPI_loading: state.staff_dashboard.BillableKPI_loading,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    billableKPIOnDashboadPermission: billableKPIOnDashboadPermission,    
    OAResponse_loading: state.staff_dashboard.OAResponse_loading,
    PayerResponse_loading: state.staff_dashboard.PayerResponse_loading,
    OrganizationOAResponses: state.staff_dashboard ? state.staff_dashboard.OrganizationOAResponses : {},
    OrganizationPayerResponses: state.staff_dashboard ? state.staff_dashboard.OrganizationPayerResponses : {},    
    masterCancelType: state.staff_dashboard.master_data ? state.staff_dashboard.master_data.masterCancelType : [],
    FinancialKPI_loading: state.staff_dashboard.FinancialKPI_loading,
    financialDataAnalytics: state.staff_dashboard ? state.staff_dashboard.OrganizationFinancialKPIGraph : {},
    viewStaffAndClientOnDashboadPermission: viewStaffAndClientOnDashboadPermission,
    OARejectionsOnDashboadPermission: OARejectionsOnDashboadPermission,
    financialSummaryKPIOnDashboadPermission: financialSummaryKPIOnDashboadPermission,
    appointmentsPermission: appointmentsPermission,
    PayerDenialsOnDashboadPermission: PayerDenialsOnDashboadPermission,
  };
};

export default connect(mapStateToProps, { 
  getExportCSVOrExcelClientNonAdminDocuments,
  getExportCSVOrExcelStaffNonAdminDocuments,
  getExportCSVOrExcelStaffDocuments,
  getExportCSVOrExcelClientDocuments,
  getExportCSVOrExcelAuthorizationDocuments,
  getDashboardData,
  getOrganizationAuthorization,
  getOrganizationEncounter,
  getStaffEncounters,
  HideStaffPasswordStatusMessage,
  getOrganizationStaffDocuments,
  getOrganizationClientDocuments,
  getStaffDocuments,
  getClientDocuments,
  getMasterData,
  getPatient,
  getOrganizationBillableHoursGraph,
  getOrganizationOAResponses,
  getOrganizationPayerResponses,
  getOrganizationFinancialKPIGraph 
})(StaffDashBoard);




// WEBPACK FOOTER //
// ./src/modules/Dashboards/components/staff_dashboard.js